<main class="c-main">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12"></div>
            <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
                {{ erro }}
            </div>
        </div>
        <div class="mat-elevation-z8">
            <mat-card>
                <mat-card-title>
                    <mat-icon>color_lens</mat-icon>
                    Usuário
                </mat-card-title>
                <mat-tab-group mat-align-tabs="start" #tabGroup>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon>add</mat-icon>
                            Cadastrar Usuário
                        </ng-template>
                        <mat-card>
                            <form [formGroup]="formulario" (ngSubmit)="submit()">
                                <div class="row">

                                    <div class="col-1">
                                        <mat-form-field class="full-width" style="width: 100%;" appearance="fill">
                                            <mat-label>ID</mat-label>
                                            <input formControlName="id" matInput readonly>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-3">
                                        <mat-form-field class="full-width" style="width: 100%;" appearance="fill">
                                            <mat-label>Username</mat-label>
                                            <input formControlName="username" matInput required>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-2">
                                        <mat-form-field class="full-width" style="width: 100%;" appearance="fill">
                                            <mat-label>Senha</mat-label>

                                            <input matInput formControlName="password"
                                                [type]="hide ? 'password' : 'text'" required>

                                            <button mat-icon-button matSuffix (click)="hide = !hide"
                                                [attr.aria-label]="'Ocultar senha'" [attr.aria-pressed]="hide">
                                                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                            </button>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-3">
                                        <mat-form-field class="full-width" style="width: 100%;" appearance="fill">
                                            <mat-label>Nome</mat-label>
                                            <input formControlName="name" matInput required>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-2">
                                        <mat-form-field class="full-width" style="width: 100%;" appearance="fill">
                                            <mat-label>Perfil de Acesso</mat-label>
                                            <mat-select formControlName="perfil" [compareWith]="compararCampos" required>
                                                <mat-option *ngFor="let perfil of perfis" [value]="perfil.id">
                                                    {{ perfil.nome }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-1">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Ativo</mat-label>
                                            <mat-select formControlName="ativo" required>
                                                <mat-option [value]="true">Sim</mat-option>
                                                <mat-option [value]="false">Não</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                </div>

                                <div class="row justify-content-between">
                                    <div class="col-6">
                                        <!-- habilita desabilita botão com o forma validate -->
                                        <button (click)="limparFormulario()" mat-raised-button>
                                            <mat-icon>insert_drive_file</mat-icon>
                                            Limpar
                                        </button>
                                    </div>
                                    <div class="col-6" align="right">
                                        <!-- habilita desabilita botão com o forma validate -->
                                        <button [disabled]="!formulario.valid" mat-raised-button color="primary">
                                            <mat-icon>save</mat-icon>
                                            Salvar
                                        </button>
                                    </div>
                                </div>

                            </form>

                        </mat-card>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon>list</mat-icon>
                            Listar Usuários
                        </ng-template>
                        <mat-card>
                            <div class="row">
                                <div class="col-4">
                                    <mat-form-field appearance="fill" style="width: 100%;">
                                        <mat-label>Consulta Por</mat-label>
                                        <mat-select id="tipoFiltro" name="tipoFiltro" [(value)]="tipoFiltro" required>
                                            <mat-option [value]="tipoFiltro"
                                                *ngFor="let tipoFiltro of tipoFiltros">{{tipoFiltro}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-6" *ngIf="tipoFiltro == 'Nome'">
                                    <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                        <mat-label>Nome</mat-label>
                                        <input [(ngModel)]="parametroConsulta" name="parametroConsulta" matInput>
                                    </mat-form-field>
                                </div>
                                <div class="col-6" *ngIf="tipoFiltro == 'Telefone'">
                                    <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                        <mat-label>Telefone</mat-label>
                                        <input [(ngModel)]="parametroConsulta" name="parametroConsulta"
                                            mask="(00) 0 0000-0000 || (00) 0000-0000" matInput>
                                    </mat-form-field>
                                </div>

                                <div class="col-2">
                                    <button (click)="consultar()" mat-raised-button color="primary"
                                        style="line-height: 51px;width: 100%;">
                                        <mat-icon>search</mat-icon>
                                        Consultar
                                    </button>
                                </div>

                            </div>
                            <table mat-table [dataSource]="usuarios" class="full-width">
                                <ng-container matColumnDef="id">
                                    <th mat-header-cell *matHeaderCellDef> ID </th>
                                    <td mat-cell *matCellDef="let usuario"> {{ usuario.id }} </td>
                                </ng-container>

                                <ng-container matColumnDef="username">
                                    <th mat-header-cell *matHeaderCellDef> Username </th>
                                    <td mat-cell *matCellDef="let usuario"> {{ usuario.username }} </td>
                                </ng-container>



                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef> Nome </th>
                                    <td mat-cell *matCellDef="let usuario"> {{ usuario.name }} </td>
                                </ng-container>

                                <ng-container matColumnDef="ativo">
                                    <th mat-header-cell *matHeaderCellDef> Ativo </th>
                                    <td mat-cell *matCellDef="let usuario"> {{ usuario.ativo ? "Sim" : "Não" }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="acoes">
                                    <th mat-header-cell *matHeaderCellDef> Ações </th>
                                    <td mat-cell *matCellDef="let usuario">
                                        <button (click)="editar(usuario.id)" (click)="tabGroup.selectedIndex = 0"
                                            mat-icon-button color="accent" title="Editar Usuário">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                        <button mat-icon-button color="warn" title="Excluir Usuário">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <!-- definir como vai ser as linhas e a ordem das colunas -->
                                <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
                                <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;"></tr>
                            </table>

                            <!-- paginação -->
                            <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
                                [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)">
                                <!-- evento de paginar -->
                            </mat-paginator>
                        </mat-card>
                    </mat-tab>


                </mat-tab-group>


            </mat-card>



        </div>
    </div>
</main>